import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { TextField } from '@material-ui/core';
import { Icon } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const RejectRequestView = props => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("div", {
    className: "flex-container space-between",
    children: /*#__PURE__*/_jsx("div", {
      className: "mb-5",
      children: /*#__PURE__*/_jsx("h1", {
        "data-id": "request-title",
        className: "ml-6 mb-0",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "request.page.rejectRequest"
        })
      })
    })
  }), /*#__PURE__*/_jsxs("form", {
    onSubmit: props.onSubmit,
    children: [/*#__PURE__*/_jsx(TextField, {
      label: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "request.page.rejectRequestReasonLabel"
        }), " *"]
      }),
      error: props.emptyReasonError,
      helperText: props.emptyReasonError ? /*#__PURE__*/_jsx(Translate, {
        value: "error.required"
      }) : null,
      multiline: true,
      minRows: 3,
      maxRows: 20,
      inputProps: {
        maxLength: 1024
      },
      value: props.reason,
      onChange: props.onReasonChange
    }), /*#__PURE__*/_jsxs("div", {
      className: "actions col-12 inline-container space-between",
      children: [/*#__PURE__*/_jsxs("button", {
        type: "button",
        className: "large secondary inline-container",
        onClick: props.onClose,
        "data-id": "cancel",
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "go-back"
        }), /*#__PURE__*/_jsx(Translate, {
          value: "action.cancel"
        })]
      }), /*#__PURE__*/_jsxs("button", {
        "data-id": "submit-button",
        className: "large cta inline-container",
        type: "submit",
        disabled: props.loading,
        children: [/*#__PURE__*/_jsx(Translate, {
          value: 'action.confirm'
        }), /*#__PURE__*/_jsx(Icon, {
          icon: props.loading ? 'loader' : 'check'
        })]
      })]
    })]
  })]
});
RejectRequestView.propTypes = {
  reason: PropTypes.string,
  emptyReasonError: PropTypes.bool.isRequired,
  onReasonChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};
export default RejectRequestView;